import { render, staticRenderFns } from "./TSelectable.vue?vue&type=template&id=16301a98"
import script from "./TSelectable.vue?vue&type=script&lang=js"
export * from "./TSelectable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports